<template>
    <v-flex>
      <v-card dark>
        <v-card-title primary-title>
            <v-icon>insert_drive_file</v-icon>
            <h4 class="mb-0">{{ fileName }}</h4>
        </v-card-title>
        <v-card-actions>
          <v-flex>
            <v-btn color="success" @click="uploadFile">
              Proceed upload
              <v-icon right>
                cloud_upload
              </v-icon>
            </v-btn>
            <v-btn color="error" @click="clearFile">
              <v-icon>
                clear
              </v-icon>
            </v-btn>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-flex>
</template>

<script>
  export default {
    name: 'FileToUpload',
    props: {
      fileName: {
        type: String,
        required: true
      }
    },
    methods: {
      clearFile () {
        this.$emit('clearFile')
      },
      uploadFile () {
        this.$emit('uploadFile')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/shared/Upload/fileToUpload.vue